import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M16 17H9l3-3-9-9 1-1 9 9 3-3z'],
  height: 20,
  width: 20,
});
